/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Coach_FullInputs */

const en_hero_coach_full = /** @type {(inputs: Hero_Coach_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked up this week`)
};

const pl_hero_coach_full = /** @type {(inputs: Hero_Coach_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęty w tym tygodniu`)
};

/**
* | output |
* | --- |
* | "Booked up this week" |
*
* @param {Hero_Coach_FullInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_coach_full = /** @type {((inputs?: Hero_Coach_FullInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Coach_FullInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_coach_full(inputs)
	return en_hero_coach_full(inputs)
});